import React, { Component } from 'react';
import classNames from 'classnames';
import Population from '../detail-components/population';
import PurchasingPower from '../detail-components/purchasing-power';
import Origin from '../detail-components/origin';
import Household from '../detail-components/household';
import Education from '../detail-components/education';
import Demographics from '../detail-components/demographics';
import SpinnerDots from '../../spinner/dots';
import withAuthProvider from '../../../hoc/withAuthProvider';
import { REACT_APP_API_BASE } from '../../../config';
import './scb-stats.scss';

class ScbStats extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1,
            stats: null,
            isLoading: false,
            noSelection: true
        };

        this.controller = null;
        this.lastFetchedSelectionKey = null;
    }

    hasAnySelection(layerSelection = {}) {
        const {
            aregion,
            county,
            localities,
            municipality,
            postalCodes
        } = layerSelection;

        return Boolean(
            (Array.isArray(aregion) && aregion.length > 0) ||
            (Array.isArray(county) && county.length > 0) ||
            (Array.isArray(localities) && localities.length > 0) ||
            (Array.isArray(municipality) && municipality.length > 0) ||
            (Array.isArray(postalCodes) && postalCodes.length > 0)
        );
    }

    buildSelectionKey(layerSelection = {}, districtId = null) {
        const toSortedArray = (value) => (Array.isArray(value) ? [...value].sort() : []);
        const keyPayload = {
            districtId,
            aregion: toSortedArray(layerSelection.aregion),
            county: toSortedArray(layerSelection.county),
            localities: toSortedArray(layerSelection.localities),
            municipality: toSortedArray(layerSelection.municipality),
            postalCodes: toSortedArray(layerSelection.postalCodes)
        };

        return JSON.stringify(keyPayload);
    }

    async fetchScbStats({
        aregion,
        county,
        localities,
        municipality,
        parish,
        postalCodes }) {
        
        const token = await this.props.getAccessToken();
        const headers = new Headers();
        const bearer = `Bearer ${token}`;
        headers.append('Authorization', bearer);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        
        if (this.controller) {
            this.controller.abort();
        }

        this.controller = new AbortController();
        const { signal } = this.controller;
        
        const path = `${REACT_APP_API_BASE}/salesdistrict/scbdata`;
        try {
            const rawResponse = await fetch(path, {
                signal,
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    aregion,
                    county,
                    localities,
                    municipality,
                    parish,
                    postalCodes
                })
            });
        
            if (rawResponse.ok) {
                const stats = await rawResponse.json();
                return {
                    scbReportData: stats.scbReportData,
                    isLoading: false
                }
            }
        } catch(e) {
            return {
                scbReportData:this.state.stats,
                isLoading: true
            };
        }
    }

    async loadScbStats() {
        // Vänta på att användaren är autentiserad innan vi försöker hämta token
        if (!this.props.isAuthenticated) {
            return;
        }

        const {
            aregion,
            county,
            localities,
            municipality,
            postalCodes } = this.props.layerSelection || {};

        this.setState({
            isLoading: true
        });

        const scbStats = await this.fetchScbStats(this.props.layerSelection || {});
        
        if (!scbStats) return;

        this.setState({
            stats: scbStats.scbReportData,
            isLoading: scbStats.isLoading,
            noSelection: !aregion || (aregion.length === 0 && 
                         (!county || county.length === 0) && 
                         (!localities || localities.length === 0) && 
                         (!municipality || municipality.length === 0) && 
                         (!postalCodes || postalCodes.length === 0))
        });   
    }

    maybeLoadScbStats() {
        const { districtId, layerSelection, isAuthenticated } = this.props;

        if (!isAuthenticated || !districtId) {
            return;
        }

        if (!this.hasAnySelection(layerSelection)) {
            return;
        }

        const selectionKey = this.buildSelectionKey(layerSelection, districtId);
        if (this.lastFetchedSelectionKey === selectionKey) {
            return;
        }

        this.lastFetchedSelectionKey = selectionKey;
        this.loadScbStats();
    }

    componentDidMount() {
        this.maybeLoadScbStats();
    }

    async componentDidUpdate(prevProps) {
        const authChanged = this.props.isAuthenticated !== prevProps.isAuthenticated;
        const districtChanged = this.props.districtId !== prevProps.districtId;
        const layerSelectionChanged = this.props.layerSelection !== prevProps.layerSelection;

        if (districtChanged) {
            this.lastFetchedSelectionKey = null;
        }

        if (authChanged || districtChanged || layerSelectionChanged) {
            this.maybeLoadScbStats();
        }
    }

    togglelTab(activeTab) {
        this.setState({
            activeTab
        });
    }
    
    render() {

        return (
            <div className={classNames({
                'scb-stats': true,
                'scb-stats--is-loading': this.state.isLoading
            })}>
                <header className="scb-stats__header">
                    <ul className="scb-stats__tabs">
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 1
                                    })} 
                                    onClick={() => this.togglelTab(1)}>Befolkning</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 2
                                    })} 
                                    onClick={() => this.togglelTab(2)}>Köpkraft</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 3
                                    })} 
                                    onClick={() => this.togglelTab(3)}>Ursprung</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 4
                                    })} 
                                    onClick={() => this.togglelTab(4)}>Hushåll</button>
                        </li>
                        <li>
                            <button type="button" 
                                    className={classNames({
                                        'scb-stats__tabs-item': true,
                                        'scb-stats__tabs-item--selected': this.state.activeTab === 5
                                    })} 
                                    onClick={() => this.togglelTab(5)}>Utbildning</button>
                        </li>
                    </ul>
                </header>
                
                <div className="scb-stats__content">
                    {!this.state.noSelection && this.state.stats && 
                        <div className="scb-stats__content-inner">
                            {this.state.activeTab === 1 &&
                                <div className="scb-stats__tab">
                                    <Demographics demographics={this.state.stats.populationByGenderDataset}
                                                  smallLabel={true}
                                                  modifiers={{
                                                    'demographics--small': true }} />                                
                                    <Population data={this.state.stats.populationByAgeDataset} 
                                                height={210} 
                                                heading="Åldersfördelning"
                                                modifiers={{
                                                    'scb-stats__graph': true }} />
                                </div>
                            }
                            {this.state.activeTab === 2 &&
                                <div className="scb-stats__tab">
                                    <PurchasingPower data={this.state.stats.populationByEconomicStandardDataset} 
                                                    height={210}
                                                    modifiers={{
                                                        'scb-stats__graph': true
                                                    }} />
                                </div>
                            }
                            {this.state.activeTab === 3 &&
                                <div className="scb-stats__tab">
                                    <Origin data={this.state.stats.populationByOriginDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                            {this.state.activeTab === 4 &&
                                <div className="scb-stats__tab">
                                    <Household data={this.state.stats.houseHoldTypesDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                            {this.state.activeTab === 5 &&
                                <div className="scb-stats__tab">
                                    <Education data={this.state.stats.populationByEducationDataset} 
                                            height={210}
                                            modifiers={{
                                                'scb-stats__graph': true
                                            }} />
                                </div>
                            }
                        </div>   
                    }
                    {this.state.noSelection && !this.state.isLoading &&
                        <div className="scb-stats__no-selection">
                            <p>Välj ett område för att se statistik</p>    
                        </div>
                    }
                    <SpinnerDots />
                </div>
            </div>
        );
    }
};

export default withAuthProvider(ScbStats);

